export interface ChartDataObject {
  name: string
  value: number
  size: number
}

export interface Props {
  data: ChartDataObject[]
}

export enum BallColorsTypes {
  field = 'FIELD',
  lot = 'LOT',
  neutral = 'NEUTRAL',
  good = 'GOOD',
  alert = 'ALERT',
  danger = 'DANGER',
}
